module.exports = __webpack_public_path__ + "img/DSM_IntoxicatingSpaces_play_button_2x.19f671fd.png";